export const FILTER = 'FILTER';
export const SORTING = 'SORTING';

export const setSessionFilterAction = (filter: Object) => ({
  type: FILTER,
  payload: filter
});

export const setSessionSortingAction = (filter: Object) => ({
  type: SORTING,
  payload: filter
});
